const validate = (values, requiredFields, language) => {
  const errors = {};

  if (requiredFields.includes("firstname") && !values.firstName) {
    errors.firstName = language.form && language.form.FirstName_Required;
  }
  if (requiredFields.includes("firstname") && values.firstName.length > 100) {
    errors.firstName = language.form && language.form.Invalid_Length;
  }

  if (requiredFields.includes("lastname") && !values.lastName) {
    errors.lastName = language.form && language.form.LastName_Required;
  }
  if (requiredFields.includes("lastname") && values.lastName.length > 100) {
    errors.lastName = language.form && language.form.Invalid_Length;
  }

  if (
    requiredFields.includes("civicRegistrationNumber") &&
    !values.civicRegistrationNumber
  ) {
    errors.civicRegistrationNumber =
      language.form && language.form.CivicRegistration_Required;
  } else if (
    !/^(19|20)?[0-9]{6}[- ]?[0-9]{4}$/.test(
      values.civicRegistrationNumber.trim()
    )
  ) {
    errors.civicRegistrationNumber =
      language.form && language.form.CivicRegistration_Invalid;
  }

  return errors;
};

export default validate;
